import {
	PRESENTATION_GET_LAYOUTS,
	PRESENTATION_GET_LAYOUTS_FAILURE,
	PRESENTATION_GET_LAYOUTS_SUCCESS,
	PRESENTATION_EDIT_LAYOUT,
	PRESENTATION_EDIT_LAYOUT_FAILURE,
	PRESENTATION_EDIT_LAYOUT_SUCCESS,
	PRESENTATION_LAYOUTS_PROPS_CHANGED,
	PRESENTATION_SELECTING_PROP_CHANGED,
	PRESENTATION_SECTION_SELECTED_PROP_CHANGED,
	PRESENTATION_EDITING_SECTION_PROP_CHANGED, PRESENTATION_PROPS_CHANGED,
} from "./actions";
import {debug} from "../../utility/functions";

// Dispatch function for getting the layouts from the API

export const dispatchOnPresentationGetLayouts = () => dispatch => {
	dispatch({type: PRESENTATION_GET_LAYOUTS});
};

export const dispatchOnPresentationGetLayoutsSuccess = (response) => dispatch => {
	dispatch({
		type: PRESENTATION_GET_LAYOUTS_SUCCESS,
		layout: response.data,
		layouts: response.layouts,
		newLayout: response.data,
	})
};

export const dispatchOnPresentationGetLayoutsFailure = () => dispatch => {
	dispatch({
		type: PRESENTATION_GET_LAYOUTS_FAILURE,
	})
};

// Dispatch functions for saving changes to the layout into the API

export const dispatchOnPresentationEditLayout = () => dispatch => {
	dispatch({type: PRESENTATION_EDIT_LAYOUT});
};

export const dispatchOnPresentationEditLayoutSuccess = (layout) => dispatch => {
	dispatch({
		type: PRESENTATION_EDIT_LAYOUT_SUCCESS,
		layout,
	})
};

export const dispatchOnPresentationEditLayoutFailure = () => dispatch => {
	dispatch({
		type: PRESENTATION_EDIT_LAYOUT_FAILURE,
	})
};

// Dispatch function to update the props layout with any changes done to the layout

export const dispatchOnPresentationLayoutChanged = (layout) => dispatch => {
	dispatch({
		type:PRESENTATION_LAYOUTS_PROPS_CHANGED,
		layout
	})
};

// Dispatch function to display or hide the modal to select articles for the layout sections

export const dispatchOnPresentationSelectingPropChanged = (selecting, selectedSection) => dispatch => {
	dispatch({
		type: PRESENTATION_SELECTING_PROP_CHANGED,
		selecting,
		selectedSection
	})
};

// Dispatch function to display an input element to change the sections name

export const dispatchOnPresentationSectionEditingChanged = (sectionEditing) => dispatch => {
	dispatch({
		type: PRESENTATION_EDITING_SECTION_PROP_CHANGED,
		sectionEditing
	})
};

// Dispatch function to store the section to which we want to add the selected articles from the modal

export const dispatchOnPresentationSectionSelectedChanged = (sectionSelected) => dispatch => {
	dispatch({
		type: PRESENTATION_SECTION_SELECTED_PROP_CHANGED,
		sectionSelected,
	})
};

export const dispatchOnPresentationHasArticlesChanged = (hasArticles) => dispatch => {
	dispatch({
		type: PRESENTATION_PROPS_CHANGED,
		hasArticles,
	})
};

export const dispatchOnPresentationHeaderChanged = (headerName, headerIndex) => dispatch => {
	dispatch({
		type: PRESENTATION_PROPS_CHANGED,
		headerName,
		headerIndex,
	})
};




// This function changes any key in layout with a new value and returns the new layout;

export const changeKeyValueInLayout = (newLayout, key, value) => {
	const layout = {...newLayout};
	layout[key] = value;
	return layout;
};

// This functions checks if the layout has any changes compared to the original one

export const doesLayoutHaveChages = (origLayout, newLayout) => {
	return Object.keys(origLayout).some((k) => {
		if(typeof origLayout[k] === 'object') {
			if(Object.keys(origLayout[k]).length !== Object.keys(newLayout[k]).length) return true;
			if(doesLayoutHaveChages(origLayout[k], newLayout[k])) return true;
		} else {
			if(origLayout && newLayout){
				if(origLayout[k] !== newLayout[k]){
					return true;
				}
			} else {
				if(origLayout || newLayout) return true;
			}
		}
		return false;
	})
};

// This function handles the reorder of the layout for the drag and drop operations

export const reorderLayout = (newLayout, {source, destination}, index) => {
	if(!source || !destination) return null;
	const key = getContentArrayKey(index);
	const layout = {...newLayout};
	const layoutArray = [];
	const fromIndex = source.index;
	const toIndex = destination.index;
	layout[key].forEach((value, index) => {
		if(layout[key].length === 1) {
			layoutArray.push(value)
		} else {
			if(index === toIndex) {
				if(fromIndex > toIndex) {
					layoutArray.push(layout[key][fromIndex]);
					layoutArray.push(value)
				} else {
					layoutArray.push(value);
					layoutArray.push(layout[key][fromIndex])
				}

			} else if(index !== fromIndex) {
				layoutArray.push(value);
			}
		}
	});
	layout[key] = [...layoutArray];
	return layout;
};

// This functions removes content from the layout and returns the new layout

export const removeContentFromLayout = (newLayout, contentIndex, index) => {
	const layout = {...newLayout};
	const key = getContentArrayKey(contentIndex);
	layout[key] = layout[key].filter((l, i) => i !== index);
	return layout;
};

// This two functions simply return the key with a provided index from a loop of elements

export const getContentKey = (index) => 'content_' + (index + 1);
export const getContentArrayKey = (index) => 'content_' + (index + 1) + '_array';

// Styling

export const getListStyle = (isDraggingOver) => ({

	width: '100%'
});

export const getcontentStyle = (draggableStyle, isDragging) => ({
	// some basic styles to make the contents look a bit nicer
	userSelect: 'none',

	// change background colour if dragging
	background: isDragging ? 'lightgreen' : 'grey',

	// styles we need to apply on draggables
	...draggableStyle
});
